import React from 'react';

import ErrorComponent from '../../components/Error';

import { useApi } from '../../utils/hooks';

import '../../utils/styles/Sport.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons';

function Sport() {
    const { data, loading, error } = useApi('sport/');

    // Display the error message if the request fails
    if (loading) return <div className="container">Chargement...</div>;

    // Display a loading message while the request is pending
    if (error) return <ErrorComponent title="Error" errorObject={error} />;

    const lastDocument =
        data.results && data.results.length > 0
            ? data.results[data.results.length - 1]
            : null;

    return (
        <div className="container">
            <p className="title-3">Sport</p>
            <div className="content">
                <p className="paragraph">
                    L'Université de Namur vise à encourager l'éveil et le
                    perfectionnement dans une ou plusieurs disciplines. Plus de
                    vingt sports différents sont proposés sur le campus et aux
                    environs, du lundi au vendredi. Une salle de fitness est
                    également accessible (10, rue Godfroid).
                </p>
            </div>

            <div className="content">
                <p className="title">Activités</p>
                <p className="paragraph">
                    L'Université offre 5 catégories d'activités : arts martiaux,
                    danse et remise en forme, sports aquatiques, sports
                    collectifs et sports individuels. Toutes les activités
                    sportives sont détaillées dans la brochure, qui est mise à
                    jour chaque mi-septembre de chaque année académiques.
                    <br /> <br />
                    Dès la rentrée académique en septembre jusqu'à la fin du
                    mois, un accès libre aux activités est offert pour permettre
                    de tester les différents sports. Notez que certaines
                    activités sont réservées aux étudiants et membres du
                    personnel UNamur (signalées par un astérisque dans la
                    brochure).
                </p>

                {lastDocument && (
                    <div id="sports-brochure-links">
                        <a className="button" href={lastDocument.full_brochure}>
                            <FontAwesomeIcon icon={faDownload} /> Consulter la
                            brochure Sports
                        </a>
                        <a
                            className="button"
                            href={lastDocument.short_brochure}
                        >
                            <FontAwesomeIcon icon={faDownload} /> Consulter
                            l'horaire hebdomadaire
                        </a>
                    </div>
                )}
            </div>

            <div className="content">
                <p className="title">Carte Sport</p>
                <p className="paragraph">
                    La <strong>carte Sport</strong> est nécessaire pour accéder
                    aux activités après la période d'essai.
                    Son coût est de 40€ pour l'année pour les étudiants de l'UNamur.
                    Il est également possible de payer 20€ par quadrimestre pour
                    ceux qui souhaitent tester une période avant de s'engager pour l'année.
                    Vous devez demander la carte au <strong>Pop-up BUMP</strong>
                     (44 rue de Bruxelles) en vous munissant d'une carte d'identité et,
                    si vous en disposez, d'une carte d'étudiant, de personnel ou UTAN.
                    Le paiement se fait par Bancontact ou Visa.
                </p>
            </div>

            <div className="content">
                <p className="title">Coordination et événements</p>
                <p className="paragraph">
                    Le <strong>VéCU</strong> (Vie Étudiante et Culturelle
                    Universitaire) coordonne les actions sportives sur le
                    campus, avec des activités encadrées par des moniteurs
                    qualifiés. Les{' '}
                    <strong>équipes sportives universitaires</strong>{' '}
                    participent à des compétitions interuniversitaires.
                    <br /> <br />
                    D'autres acteurs comme l'AGE, l'ADC et le{' '}
                    <strong>Kotésport</strong> participent également à
                    l'animation sportive du campus, organisant des événements
                    comme le <strong>Run in the Park</strong> ou le{' '}
                    <strong>Run in the Woods</strong>.
                </p>
            </div>

            <div className="content">
                <p className="title">Informations Complémentaires</p>
                <p className="paragraph">
                    Pour toute information supplémentaire, veuillez consulter la
                    brochure disponible ou nous contacter à{' '}
                    <a href="mailto:sports@unamur.be">
                        sports@unamur.be
                    </a>{' '}
                    ou par téléphone au{' '}
                    <a href="tel:+32499231908">0499/23.19.08</a>
                </p>
                <div id="sports-social-networks">
                    <a
                        className="circle"
                        href="https://www.facebook.com/profile.php?id=61558249593831"
                    >
                        <FontAwesomeIcon icon={faFacebookF} size="xl" />
                    </a>
                    <a
                        className="circle"
                        href="https://www.instagram.com/services.des.sports.unamur/"
                    >
                        <FontAwesomeIcon icon={faInstagram} size="xl" />
                    </a>
                </div>
            </div>
        </div>
    );
}

export default Sport;
